import { consent_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import type { consent } from '@axo/shared/data-access/types';
import { useMutation } from 'react-query';

export function useCreateConsent() {
  const api = useAPI();

  return useMutation(
    ({
      token,
      keepalive,
      signal,
      ...data
    }: consent.ConsentConfigData & {
      token?: string;
      keepalive?: boolean;
      signal?: AbortSignal;
    }) => {
      if (!api.token && token) api.token = token;
      return consent_api.sendMasterConsent(api)(data, { keepalive, signal });
    }
  );
}
